export const ApplicationSectionNameEnums = {
  PERSONAL_DETAILS: 'PERSONAL_DETAILS_2026',
  EXAM_SLOT_DETAILS: 'EXAM_SLOT_DETAILS_2026',
  NAT: 'NAT_EXAM_2026',
  CAMPUS_VISIT_SCHEDULER: 'CAMPUS_VISIT_SCHEDULER_2026',
  CAMPUS_VISIT_SCHEDULER_PARENT: 'CAMPUS_CONNECT_2026',
  CAMPUS_VISIT_SCHEDULER_SUCCESS: 'NIAT_OFFICE_VISIT_2026',
  APPLICATION_FEE_PAYMENT: 'APPLICATION_FEE_PAYMENT',
  BOOK_EXAM_SLOT_AND_PAY: 'BOOK_EXAM_SLOT_AND_PAY',
  TAKE_ADMISSION: 'NIAT_ADMISSION_FEE_2026',
  NIAT_ENROLLMENT_FEE_2026: 'NIAT_ENROLLMENT_FEE_2026',
  TOPIN_EXAM: 'TOPIN_EXAM_2026',
  RETAKE_EXAM_SLOT_DETAILS: 'RETAKE_EXAM_SLOT_DETAILS_2026',
  RETAKE_TOPIN_EXAM: 'RETAKE_TOPIN_EXAM_2026',
  WEBINAR: 'WEBINAR_2026',
  WEBINAR_REGISTRATION: 'WEBINAR_REGISTRATION_2026',
  ONLINE_COUNSELLING: 'ONLINE_COUNSELLING_2026',
  CLOSURE_SESSION_REGISTRATION: 'CLOSURE_REGISTRATION_2026',
  WEBINAR_VISIT: 'WEBINAR_VISIT_2026',
  COUNSELLING_COMPLETED: 'COUNSELLING_COMPLETED_2026',
  BOOK_A_PRE_COUNSELLING_SESSION: 'BOOK_A_PRE_COUNSELLING_SESSION_2026',
  BOOK_ADMISSION_TEST_FEE: 'BOOK_ADMISSION_TEST_FEE',
  NAT_SLOT_SELECTION: 'NAT_EXAM_2026',
  NIAT_APPLICATION: 'NIAT_2026',
  EXAM_SLOT_SUCCESS: 'EXAM_SLOT_SUCCESS',
  RESCHEDULE_SLOT: 'RESCHEDULE_SLOT',
  RESCHEDULE_SLOT_SUCCESS: 'RESCHEDULE_SLOT_SUCCESS',
  NAT_EXAM_QUALIFIED_SUCCESS: 'NAT_EXAM_QUALIFIED_SUCCESS',
  RETAKE_EXAM_SLOT_SUCCESS: 'RETAKE_EXAM_SLOT_SUCCESS',
  RETAKE_RESCHEDULE_SLOT: 'RETAKE_RESCHEDULE_SLOT',
  RETAKE_RESCHEDULE_SLOT_SUCCESS: 'RETAKE_RESCHEDULE_SLOT_SUCCESS',
  NAT_OFFICE_VISITED: 'NIAT_OFFICE_VISIT_2026',
  STUDENT_CAMPUS_VISIT_2026: 'STUDENT_CAMPUS_VISIT_2026',
  DIRECT_CAMPUS_VISIT_2026: 'DIRECT_CAMPUS_VISIT_2026',
  COUNSELING_SESSION: 'UI_COUNSELING_SESSION'
};

export const NAT_GUIDE_URL =
  'https://d14qv6cm1t62pm.cloudfront.net/niat/nat_instructions_2026.pdf';
